import React from 'react';
import { TableCellProps } from '../../../types/search';
import DownloadDocsBtnIndividual from './DownloadDocsBtnIndividual';
import PayInvoiceBtn from './PayInvoiceBtn';
import { useSearchConfig } from '../../Search/hooks/useSearchConfig';

const PortalCellPay: React.FC<TableCellProps> = ({ row, listingType }) => {
  const { labels, invoicePaymentUrl } = useSearchConfig();
  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--pay`}>
      <PayInvoiceBtn
        invoiceId={row['id']}
        invoiceNumber={row['referenceId']}
        dateDue={row['dateDue']}
        amount={row['outstandingBalance']}
        payButtonLabel={labels.payButtonLabel}
        invoicePaymentUrl={invoicePaymentUrl}
        additionalCtaClass="portal-cell__pay-btn"
      />
      <DownloadDocsBtnIndividual rowId={row['id']} placement="bottom end" />
    </div>
  );
};

export default PortalCellPay;
